<template>

  <header id="page-topbar">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <a class="logo logo-dark" >
                            <span class="logo-sm">
                                    <img alt="" height="22" :src="'./assets/images/logo.svg'">
                                </span>

            <span class="logo-lg">
<!--                                    <img alt="" height="17" src="/assets/images/logo-dark.png">-->
                                </span>
          </a>

          <a class="logo logo-light d-flex">
            <span class="logo-sm">
                <img alt="" height="50" :src="county_logo()">
            </span>
            <span class="logo-lg">
                <img alt="" height="45" :src="county_logo()">
            </span>


          </a>
        </div>

        <button onclick="toggleVerticalMenu()" id="vertical-menu-btn" class="btn btn-sm px-3 font-size-16 header-item waves-effect" type="button">
          <i class="fa fa-fw fa-bars"></i>
        </button>
        <!-- logo small -->
        <div class="phone-logo d-md-none d-sm-flex"><img alt="" class="img" :src="county.logo"></div>


        <!-- App Search-->
        <form class="app-search d-none d-lg-block">
          <div class="position-relative">
            <input class="form-control" placeholder="Search..." type="text">
            <span class="bx bx-search-alt"></span>
          </div>
        </form>

      </div>

      <div class="d-flex">
        <!-- small search -->
        <div class="dropdown d-inline-block d-lg-none ms-2">
          <button id="page-header-search-dropdown" aria-expanded="false" aria-haspopup="true"
                  class="btn header-item noti-icon waves-effect" data-bs-toggle="dropdown" type="button">
            <i class="mdi mdi-magnify"></i>
          </button>
          <div aria-labelledby="page-header-search-dropdown"
               class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0">

            <form class="p-3">
              <div class="form-group m-0">
                <div class="input-group">
                  <input aria-label="Recipient's username" class="form-control" placeholder="Search ..." type="text">
                  <div class="input-group-append">
                    <button class="btn btn-primary" type="submit"><i class="mdi mdi-magnify"></i></button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div class="dropdown d-none d-lg-inline-block ms-1">
          <button class="btn header-item noti-icon waves-effect" data-bs-toggle="fullscreen" type="button">
            <i class="bx bx-fullscreen"></i>
          </button>
        </div>

        <div class="dropdown d-inline-block d-none">

          <!-- notifications, i will come to this later -->
          <button id="page-header-notifications-dropdown" aria-expanded="false" aria-haspopup="true"
                  class="btn header-item noti-icon waves-effect" data-bs-toggle="dropdown" type="button">
            <i class="bx bx-bell bx-tada"></i>
            <span class="badge bg-danger rounded-pill">3</span>
          </button>
          <div aria-labelledby="page-header-notifications-dropdown"
               class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0">
            <div class="p-3">
              <div class="row align-items-center">
                <div class="col">
                  <h6 key="t-notifications" class="m-0"> Notifications </h6>
                </div>
                <div class="col-auto">
                  <a key="t-view-all" class="small" href="#!"> View All</a>
                </div>
              </div>
            </div>
            <div data-simplebar style="max-height: 230px;">
              <a class="text-reset notification-item" href="javascript: void(0);">
                <div class="d-flex">
                  <div class="avatar-xs me-3">
                                            <span class="avatar-title bg-primary rounded-circle font-size-16">
                                                    <i class="bx bx-cart"></i>
                                                </span>
                  </div>
                  <div class="flex-grow-1">
                    <h6 key="t-your-order" class="mb-1">Your order is placed</h6>
                    <div class="font-size-12 text-muted">
                      <p key="t-grammer" class="mb-1">If several languages coalesce the grammar</p>
                      <p class="mb-0"><i class="mdi mdi-clock-outline"></i> <span key="t-min-ago">3 min ago</span></p>
                    </div>
                  </div>
                </div>
              </a>
              <a class="text-reset notification-item" href="javascript: void(0);">
                <div class="d-flex">
                  <img alt="user-pic" class="me-3 rounded-circle avatar-xs" :src="'./assets/images/users/avatar-3.jpg'">
                  <div class="flex-grow-1">
                    <h6 class="mb-1">James Lemire</h6>
                    <div class="font-size-12 text-muted">
                      <p key="t-simplified" class="mb-1">It will seem like simplified English.</p>
                      <p class="mb-0"><i class="mdi mdi-clock-outline"></i> <span key="t-hours-ago">1 hours ago</span>
                      </p>
                    </div>
                  </div>
                </div>
              </a>

              <a class="text-reset notification-item" href="javascript: void(0);">
                <div class="d-flex">
                  <div class="avatar-xs me-3">
                                            <span class="avatar-title bg-success rounded-circle font-size-16">
                                                    <i class="bx bx-badge-check"></i>
                                                </span>
                  </div>
                  <div class="flex-grow-1">
                    <h6 key="t-shipped" class="mb-1">Your item is shipped</h6>
                    <div class="font-size-12 text-muted">
                      <p key="t-grammer" class="mb-1">If several languages coalesce the grammar</p>
                      <p class="mb-0"><i class="mdi mdi-clock-outline"></i> <span key="t-min-ago">3 min ago</span></p>
                    </div>
                  </div>
                </div>
              </a>

              <a class="text-reset notification-item" href="javascript: void(0);">
                <div class="d-flex">
                  <img alt="user-pic" class="me-3 rounded-circle avatar-xs" :src="'./assets/images/users/avatar-4.jpg'">
                  <div class="flex-grow-1">
                    <h6 class="mb-1">Salena Layfield</h6>
                    <div class="font-size-12 text-muted">
                      <p key="t-occidental" class="mb-1">As a skeptical Cambridge friend of mine occidental.</p>
                      <p class="mb-0"><i class="mdi mdi-clock-outline"></i> <span key="t-hours-ago">1 hours ago</span>
                      </p>
                    </div>
                  </div>
                </div>
              </a>
            </div>
            <div class="p-2 border-top d-grid">
              <a class="btn btn-sm btn-link font-size-14 text-center" href="javascript:void(0)">
                <i class="mdi mdi-arrow-right-circle me-1"></i> <span key="t-view-more">View More..</span>
              </a>
            </div>
          </div>
        </div>


        <div class="dropdown d-inline-block">
          <button type="button" class="btn header-item waves-effect" id="page-header-user-dropdown"
                  data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span class="d-none d-xl-inline-block ms-1" key="t-henry">{{sessionNames}}</span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </button>

          <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="page-header-user-dropdown">
            <li>
              <a class="dropdown-item" href="javascript:void(0);" @click="gotTo('employee-profile')">
                <i class="bx bx-user font-size-16 align-middle me-1"></i>
                My Profile
              </a>
            </li>
            <li><hr class="dropdown-divider"></li>
            <li>
              <a class="dropdown-item" href="javascript:void(0);" @click="gotTo('change-password')">
                <i class="bx bx-lock-open font-size-16 align-middle me-1"></i>
                Change Password
              </a>
            </li>
            <li><hr class="dropdown-divider"></li>
            <li>
              <a class="dropdown-item text-danger" href="javascript:void(0);" @click="logout('/')">
                <i class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
                Logout
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </header>
  <div id="vertical-menu" class="vertical-menu" >

    <div class="h-100" data-simplebar>

      <!--- Sidemenu -->
      <div id="sidebar-menu" >
        <!-- Left Menu Start -->
        <ul id="side-menu" class="metismenu list-unstyled text-capitalize">
          <li key="t-pages" class="menu-title d-none"></li>


          <li  v-if="getRight('DASHBOARD')" :class="{ 'mm-active': selected === 'dashboard' }">
            <a @click="gotToSelected('dashboard')" class="waves-effect">
              <i class="bx bx-home-circle"></i><span>Dashboard</span>
            </a>


          </li>

          <li  v-if="getRight('EMPLOYEE REGISTER')">
            <a href="javascript: void(0);" @click="gotToSelected('employee-register')" class="waves-effect">
              <i class="mdi mdi-account-group"></i><span>Employee Register</span>
            </a>
          </li>

          <li  v-if="getRight('DEPARTMENT MANAGEMENT')">
            <a href="javascript: void(0);" @click="gotToSelected('department-management')" class="waves-effect">
              <i class="mdi-account-multiple"></i><span>Departments</span>
            </a>
          </li>

          <li  v-if="getRight('SEPARATION')" :class="{ 'mm-active': selected === 'separation' }">

            <a @click="selectedMenu('separation')" class="waves-effect has-arrow">
              <i class="mdi mdi-logout-variant"></i>
              <span>Separation</span>
            </a>

            <ul :class="{ 'mm-active': selected === 'separation' }" class="sub-menu" aria-expanded="false">

              <li v-if="getRight('TERMINATION')" :class="{ 'mm-active': selectedSub === 'separation-termination' }" ><a href="javascript: void(0);" @click="gotTo('separation-termination')"> <i class="mdi mdi-close-circle"></i>Termination</a></li>
              <li v-if="getRight('FNF')" :class="{ 'mm-active': selectedSub === 'separation-fnf' }" ><a href="javascript: void(0);" @click="gotTo('separation-fnf')"><i class="mdi mdi-cash"></i> FNF</a></li>

            </ul>
          </li>

          <li v-if="getRight('DOCUMENTS')" :class="{ 'mm-active': selected === 'documents' }">
            <a @click="selectedMenu('documents')" class="waves-effect has-arrow" href="javascript: void(0);">
              <i class="mdi mdi-file-document"></i>
              <span>Documents</span>
            </a>
            <ul aria-expanded="false"  v-if="getRight('DOCUMENTS')" :class="{ 'mm-active': selected === 'documents' }" class="sub-menu">
              <li v-if="getRight('GENERAL DOCUMENTS')" :class="{ 'mm-active': selectedSub === 'documents-general' }"><a href="javascript: void(0);" @click="gotTo('documents-general')"><i class="mdi mdi-file"></i> General Documents</a></li>
            </ul>
          </li>

          <li v-if="getRight('IMPREST')" :class="{ 'mm-active': selected === 'imprest' }">
            <a @click="selectedMenu('imprest')" class="waves-effect has-arrow">
              <i class="mdi mdi-cash"></i>
              <span>Imprest</span>
            </a>
            <ul :class="{ 'mm-active': selected === 'imprest' }" class="sub-menu" aria-expanded="false">
              <li v-if="getRight('IMPREST REQUEST')" :class="{ 'mm-active': selectedSub === 'imprest-request' }">
                <a href="javascript: void(0);" @click="gotTo('imprest-request')">
                  <i class="mdi mdi-plus-circle"></i> Imprest Request
                </a>
              </li>
              <li v-if="getRight('IMPREST APPROVAL')" :class="{ 'mm-active': selectedSub === 'imprest-approval' }">
                <a href="javascript: void(0);" @click="gotTo('imprest-approval')">
                  <i class="mdi mdi-check-circle"></i> Imprest Approval
                </a>
              </li>
              <li v-if="getRight('IMPREST RECONCILIATION')" :class="{ 'mm-active': selectedSub === 'imprest-reconciliation' }">
                <a href="javascript: void(0);" @click="gotTo('imprest-reconciliation')">
                  <i class="mdi mdi-file-compare"></i> Imprest Recon
                </a>
              </li>
              <li v-if="getRight('IMPREST HISTORY')" :class="{ 'mm-active': selectedSub === 'imprest-history' }">
                <a href="javascript: void(0);" @click="gotTo('imprest-history')">
                  <i class="mdi mdi-history"></i> Imprest History
                </a>
              </li>
            </ul>
          </li>

          <li  v-if="getRight('EMPLOYEE APPROVALS')" :class="{ 'mm-active': selected === 'Payments & Receipting' }">
            <a @click="selectedMenu('Payments & Receipting')" class="waves-effect has-arrow" href="javascript: void(0);">
              <i class="mdi mdi-check-decagram"></i>
              <span>Employee Approvals</span>
            </a>
            <ul aria-expanded="false" class="sub-menu" :class="{ 'mm-active': selected === 'Payments & Receipting' }">
              <li v-if="getRight('PENDING APPROVALS NEW EMPLOYEES')" :class="{ 'mm-active': selectedSub === 'employee-approvals-new' }"><a style="cursor: pointer;" @click="gotTo('employee-approvals-new')"><i class="mdi mdi-account-check"></i> Pending Approvals - New Employees</a></li>
              <li v-if="getRight('PENDING APPROVALS DATA EDITS')" :class="{ 'mm-active': selectedSub === 'employee-approvals-edit-approvals' }"><a style="cursor: pointer;" @click="gotTo('employee-approvals-edit-approvals')"><i class="mdi mdi-pencil"></i> Pending Approvals - Data Edits</a></li>
              <li v-if="getRight('REJECTED APPROVALS')" :class="{ 'mm-active': selectedSub === 'employee-approvals-rejected' }"><a style="cursor: pointer;" @click="gotTo('employee-approvals-rejected')"><i class="mdi mdi-close-circle"></i> Rejected</a></li>
            </ul>
          </li>

          <li v-if="getRight('REPORTS')" :class="{ 'mm-active': selected === 'reports' }">
            <a @click="selectedMenu('reports')" class="waves-effect has-arrow" href="javascript: void(0);">
              <i class="mdi mdi-file-chart"></i>
              <span>Reports</span>
            </a>
            <ul aria-expanded="false" class="sub-menu" :class="{ 'mm-active': selected === 'reports' }">
              <li v-if="getRight('DAILY ATTENDANCE')" :class="{ 'mm-active': selectedSub === 'report-daily' }"><a style="cursor: pointer;" @click="gotTo('report-daily')"><i class="mdi mdi-calendar-today"></i> Daily Attendance</a></li>
              <li v-if="getRight('MONTHLY ATTENDANCE')" :class="{ 'mm-active': selectedSub === 'report-monthly' }"><a style="cursor: pointer;" @click="gotTo('report-monthly')"><i class="mdi mdi-calendar-month"></i> Monthly Attendance</a></li>
              <li v-if="getRight('HR REPORT')" :class="{ 'mm-active': selectedSub === 'report-hr-report' }"><a style="cursor: pointer;" @click="gotTo('report-hr-report')"><i class="mdi mdi-account-group"></i> Dept. HR Report</a></li>
              <li v-if="getRight('LEAVE REPORT')" :class="{ 'mm-active': selectedSub === 'report-leave' }"><a style="cursor: pointer;" @click="gotTo('report-leave')"><i class="mdi mdi-airplane-off"></i> Leave</a></li>
              <li v-if="getRight('TIMESHEET REPORT')" :class="{ 'mm-active': selectedSub === 'report-timesheet' }"><a style="cursor: pointer;"  @click="gotTo('report-timesheet')"><i class="mdi mdi-clock-time-eight-outline"></i> Timesheet</a></li>
              <li v-if="getRight('AWOL REPORT')" :class="{ 'mm-active': selectedSub === 'report-awol' }"><a style="cursor: pointer;" @click="gotTo('report-awol')"><i class="mdi mdi-account-off"></i> AWOL Report</a></li>
              <li v-if="getRight('OFF DUTY DETAILS')" :class="{ 'mm-active': selectedSub === 'off-duty-details' }"><a style="cursor: pointer;" @click="gotTo('off-duty-details')"><i class="mdi mdi-account-alert"></i> Unapproved Leave (15+ Days)</a></li>
            </ul>
          </li>


          <li v-if="getRight('HR ACTIONS')" :class="{ 'mm-active': selected === 'hr-actions'}">
            <a @click="selectedMenu('hr-actions')" class="waves-effect has-arrow">
              <i class="mdi mdi-account-cog"></i>
              <span>HR Actions</span>
            </a>

            <ul  :class="{ 'mm-active': selected === 'hr-actions' }" class="sub-menu" aria-expanded="false">
              <li v-if="getRight('TRANSFERS')" :class="{ 'mm-active': selectedSub === 'hr-transfers' }" ><a href="javascript: void(0);" @click="gotTo('hr-transfers')"><i class="mdi mdi-transfer"></i> Transfers</a></li>
              <li v-if="getRight('EVENTS')" :class="{ 'mm-active': selectedSub === 'hr-events' }" ><a href="javascript: void(0);" @click="gotTo('hr-events')"><i class="mdi mdi-calendar"></i> Events</a></li>
              <li v-if="getRight('MY EVENTS')" :class="{ 'mm-active': selectedSub === 'hr-my-events' }" ><a href="javascript: void(0);" @click="gotTo('hr-my-events')"><i class="mdi mdi-calendar"></i>My Events</a></li>
              <li v-if="getRight('MEETINGS')" :class="{ 'mm-active': selectedSub === 'hr-meetings' }" ><a href="javascript: void(0);" @click="gotTo('hr-meetings')"><i class="mdi mdi-account-voice"></i> Meetings</a></li>
              <li v-if="getRight('ASSETS')" :class="{ 'mm-active': selectedSub === 'hr-assets' }" ><a href="javascript: void(0);" @click="gotTo('assets')"><i class="mdi mdi-archive"></i> Assets</a></li>
              <li v-if="getRight('PROMOTIONS')" :class="{ 'mm-active': selectedSub === 'hr-promotions' }" ><a href="javascript: void(0);" @click="gotTo('hr-promotions')"><i class="mdi mdi-arrow-up-bold"></i> Promotions</a></li>
              <li v-if="getRight('WARNINGS')" :class="{ 'mm-active': selectedSub === 'hr-warnings' }" ><a href="javascript: void(0);" @click="gotTo('hr-warnings')"><i class="mdi mdi-bullhorn"></i> Warnings</a></li>
              <li v-if="getRight('ANNOUNCEMENTS')" :class="{ 'mm-active': selectedSub === 'announcements' }" ><a href="javascript: void(0);" @click="gotTo('announcements')"><i class="mdi mdi-bullhorn"></i> Announcements</a></li>

              <li v-if="getRight('HOLIDAYS')" :class="{ 'mm-active': selectedSub === 'holidays' || selectedSub === 'holiday-categories' || selectedSub === 'holiday-calendar' || selectedSub === 'holiday-statistics' }">
                <a href="javascript: void(0);" @click="expandHolidayMenu" class="waves-effect has-arrow">
                  <i class="mdi mdi-beach"></i> Holidays
                </a>
                <ul class="sub-menu" aria-expanded="false" :class="{ 'mm-show': isHolidayMenuOpen }">
                  <li v-if="getRight('MANAGE HOLIDAYS')" :class="{ 'mm-active': selectedSub === 'holidays' }">
                    <a href="javascript: void(0);" @click="gotTo('holidays')">
                      <i class="mdi mdi-calendar-check"></i> Manage Holidays
                    </a>
                  </li>
                  <li v-if="getRight('HOLIDAY CATEGORIES')" :class="{ 'mm-active': selectedSub === 'holiday-categories' }">
                    <a href="javascript: void(0);" @click="gotTo('holiday-categories')">
                      <i class="mdi mdi-tag-multiple"></i> Categories
                    </a>
                  </li>
                  <li v-if="getRight('HOLIDAY CALENDAR')" :class="{ 'mm-active': selectedSub === 'holiday-calendar' }">
                    <a href="javascript: void(0);" @click="gotTo('holiday-calendar')">
                      <i class="mdi mdi-calendar-month"></i> Calendar
                    </a>
                  </li>
                  <li v-if="getRight('HOLIDAY STATISTICS')" :class="{ 'mm-active': selectedSub === 'holiday-statistics' }">
                    <a href="javascript: void(0);" @click="gotTo('holiday-statistics')">
                      <i class="mdi mdi-chart-bar"></i> Statistics
                    </a>
                  </li>
                </ul>
              </li>

            </ul>

          </li>

          <li v-if="getRight('LEAVE AND ATTENDANCE')" :class="{ 'mm-active': selected === 'leave-attendance' }">

            <a @click="selectedMenu('leave-attendance')" class="waves-effect has-arrow">
              <i class="mdi mdi-calendar-check"></i>
              <span>Leave & Attendance</span>
            </a>

            <ul :class="{ 'mm-active': selected === 'leave-attendance' }" class="sub-menu" aria-expanded="false">

              <li v-if="getRight('TIMESHEET')" :class="{ 'mm-active': selectedSub === 'attendance-timesheet' }" ><a href="javascript: void(0);" @click="gotTo('attendance-timesheet')"><i class="mdi mdi-clock-time-four"></i> Timesheet</a></li>
              <li v-if="getRight('MANAGE ATTENDANCE')" :class="{ 'mm-active': selectedSub === 'report-monthly' }" ><a href="javascript: void(0);" @click="gotTo('report-monthly')"><i class="mdi mdi-account-check"></i> Manage Attendance</a></li>

              <li v-if="getRight('MANAGE LEAVE')" :class="{ 'mm-active': selectedSub === 'attendance-leave' }" ><a href="javascript: void(0);" @click="gotTo('attendance-leave')"><i class="mdi mdi-calendar"></i>Leave Approval</a></li>
              <li v-if="getRight('MANAGE LEAVE')" :class="{ 'mm-active': selectedSub === 'attendance-leave-manage' }" ><a href="javascript: void(0);" @click="gotTo('attendance-leave-manage')"><i class="mdi mdi-calendar-remove"></i>Leave Balances</a></li>
              <li v-if="getRight('MANAGE LEAVE')" :class="{ 'mm-active': selectedSub === 'leave-types' }" ><a href="javascript: void(0);" @click="gotTo('leave-types')"><i class="mdi mdi-calendar-remove"></i>Leave Types</a></li>


            </ul>
          </li>

          <li v-if="getRight('EMPLOYEE PERFORMANCE')" :class="{ 'mm-active': selected === 'performance' }">
            <a @click="selectedMenu('performance')" class="waves-effect has-arrow">
              <i class="mdi mdi-chart-line"></i>
              <span>Performance Management</span>
            </a>

            <ul :class="{ 'mm-active': selected === 'performance' }" class="sub-menu" aria-expanded="false">

              <li v-if="getRight('MY APPRAISALS')" :class="{ 'mm-active': selectedSub === 'my-appraisals' }">
                <a href="javascript: void(0);" @click="gotTo('my-appraisals')">
                  <i class="mdi mdi-file-document-outline"></i>My Appraisals
                </a>
              </li>
              <li v-if="getRight('EMPLOYEE SELF ASSESSMENT')" :class="{ 'mm-active': selectedSub === 'employee-self-assessment' }">
                <a href="javascript: void(0);" @click="gotTo('employee-self-assessment')">
                  <i class="mdi mdi-pencil-box-outline"></i>Self Assessment
                </a>
              </li>

              <li v-if="getRight('MANAGER DASHBOARD')" :class="{ 'mm-active': selectedSub === 'manager-dashboard' }">
                <a href="javascript: void(0);" @click="gotTo('manager-dashboard')">
                  <i class="mdi mdi-account-supervisor"></i>Manage Team Appraisals
                </a>
              </li>

              <li v-if="getRight('HR DASHBOARD')" :class="{ 'mm-active': selectedSub === 'hr-dashboard' }">
                <a href="javascript: void(0);" @click="gotTo('hr-dashboard')">
                  <i class="mdi mdi-shield-account"></i>HR Dashboard
                </a>
              </li>

              <li v-if="getRight('PERFORMANCE REPORTS')" :class="{ 'mm-active': selectedSub === 'performance-reports' }">
                <a href="javascript: void(0);" @click="gotTo('performance-reports')">
                  <i class="mdi mdi-chart-bar"></i>Reports & Analytics
                </a>
              </li>
            </ul>
          </li>


          <li class="d-none"  v-if="getRight('ASSETS')" :class="{ 'mm-active': selected === 'assets' }">
            <a @click="selectedMenu('assets')" class="waves-effect has-arrow">
              <i class="mdi mdi-folder-open"></i>
              <span>Asset</span>
            </a>

            <ul  :class="{ 'mm-active': selected === 'assets' }" class="sub-menu" aria-expanded="false">
              <li v-if="getRight('ASSET TRACKING')" :class="{ 'mm-active': selectedSub === 'assets-all' }"><a href="javascript: void(0);" @click="gotTo('assets-all')"><i class="mdi mdi-barcode-scan"></i> Asset Tracking</a></li>
              <li v-if="getRight('REGISTER NEW ASSET')" :class="{ 'mm-active': selectedSub === 'assets-new' }"><a href="javascript: void(0);" ><i class="mdi mdi-plus-box"></i> Register New Asset</a></li>
            </ul>
          </li>

          <li  v-if="getRight('PAYROLL RECONCILIATION')" :class="{ 'mm-active': selected === 'payroll-reconciliation'}">
            <a @click="selectedMenu('payroll-reconciliation')" class="waves-effect has-arrow">
              <i class="mdi mdi-file-compare"></i>
              <span>Payroll</span>
            </a>
            <ul :class="{ 'mm-active': selected === 'payroll-reconciliation' }" class="sub-menu" aria-expanded="false">
              <li v-if="getRight('PAYROLL PERIODS')" :class="{ 'mm-active': selectedSub === 'payroll' }"><a href="javascript: void(0);" @click="gotTo('payroll')"><i class="mdi mdi-calendar-check"></i>Payroll Periods</a></li>
              <li v-if="getRight('PAYROLL SETUP')" :class="{ 'mm-active': selectedSub === 'payroll-setup' }"><a href="javascript: void(0);" @click="gotTo('payroll-setup')"><i class="mdi mdi-cog-outline"></i>Setup & Configuration</a></li>
              <li v-if="getRight('UPLOAD PAYROLL')" :class="{ 'mm-active': selectedSub === 'recon-upload-payroll' }"><a href="javascript: void(0);" @click="gotTo('recon-upload-payroll')"><i class="mdi mdi-upload"></i>Upload Payroll</a></li>
              <li v-if="getRight('RECON HISTORY')" :class="{ 'mm-active': selectedSub === 'recon-history'}"><a href="javascript: void(0);" @click="gotTo('recon-history')" ><i class="mdi mdi-history"></i> Recon History</a></li>
            </ul>
          </li>


          <li v-if="getRight('SETTINGS AND SETUPS')"  :class="{ 'mm-active': selected === 'settings' }">
            <a @click="selectedMenu('settings')" class="waves-effect has-arrow" href="javascript: void(0);">
              <i class="mdi mdi-cogs"></i>
              <span>Setups</span>
            </a>
            <ul :class="{ 'mm-active': selected === 'settings' }" aria-expanded="false" class="sub-menu">
              <li v-if="getRight('COUNTY REVENUE')"  :class="{ 'mm-active': selectedSub === 'department' }"><a style="cursor: pointer;" ><i class="mdi mdi-cash-multiple"></i> County Revenue</a></li>
              <li v-if="getRight('SDD CONNECTION')"  :class="{ 'mm-active': selectedSub === 'revenue-stream' }"><a style="cursor: pointer;"><i class="mdi mdi-lan"></i> SDD Connections</a></li>
              <li v-if="getRight('APPRAISAL FORM')"  :class="{ 'mm-active': selectedSub === 'targets-SubCounty' }"><a style="cursor: pointer;" href="https://homabaycountyland.fillout.com/t/5DRmYuEdUDus" target="_blank"><i class="mdi mdi-file-document-edit"></i> Appraisal Form</a></li>
              <li v-if="getRight('GENERAL SET UP')"  :class="{ 'mm-active': selectedSub === 'targets-SubCounty' }"><a style="cursor: pointer;" ><i class="mdi mdi-tune"></i> General Set Up</a></li>
            </ul>
          </li>

          <li key="t-employee-section" class="menu-title">Employee Self-Service</li>

          <li v-if="getRight('MY DASHBOARD')" :class="{ 'mm-active': selected === 'employee-dashboard' }">
            <a @click="gotToSelected('employee-dashboard')" class="waves-effect">
              <i class="mdi mdi-view-dashboard"></i><span>My Dashboard</span>
            </a>
          </li>

          <li v-if="getRight('MY PROFILE')" :class="{ 'mm-active': selected === 'employee-profile' }">
            <a @click="gotToSelected('employee-profile')" class="waves-effect">
              <i class="mdi mdi-account"></i><span>My Profile</span>
            </a>
          </li>

          <li v-if="getRight('MY LEAVE')" :class="{ 'mm-active': selected === 'employee-leave' }">
            <a @click="selectedMenu('employee-leave')" class="waves-effect has-arrow">
              <i class="mdi mdi-calendar-month"></i>
              <span>My Leave</span>
            </a>
            <ul :class="{ 'mm-active': selected === 'employee-leave' }" class="sub-menu" aria-expanded="false">
              <li v-if="getRight('APPLY FOR LEAVE')" :class="{ 'mm-active': selectedSub === 'employee-leave-apply' }">
                <a href="javascript: void(0);" @click="gotTo('employee-leave-apply')">
                  <i class="mdi mdi-plus-circle"></i> Apply for Leave
                </a>
              </li>
              <li v-if="getRight('LEAVE HISTORY')" :class="{ 'mm-active': selectedSub === 'employee-leave-history' }">
                <a href="javascript: void(0);" @click="gotTo('employee-leave-history')">
                  <i class="mdi mdi-history"></i> Leave History
                </a>
              </li>
              <li v-if="getRight('LEAVE BALANCE')" :class="{ 'mm-active': selectedSub === 'employee-leave-balance' }">
                <a href="javascript: void(0);" @click="gotTo('employee-leave-balance')">
                  <i class="mdi mdi-chart-donut"></i> Leave Balance
                </a>
              </li>
              <li v-if="getRight('LEAVE CALENDAR')" :class="{ 'mm-active': selectedSub === 'employee-leave-calendar' }">
                <a href="javascript: void(0);" @click="gotTo('employee-leave-calendar')">
                  <i class="mdi mdi-calendar"></i> Leave Calendar
                </a>
              </li>
            </ul>
          </li>

          <li v-if="getRight('MY ATTENDANCE')" :class="{ 'mm-active': selected === 'employee-attendance' }">
            <a @click="selectedMenu('employee-attendance')" class="waves-effect has-arrow">
              <i class="mdi mdi-clock-check-outline"></i>
              <span>My Attendance</span>
            </a>
            <ul :class="{ 'mm-active': selected === 'employee-attendance' }" class="sub-menu" aria-expanded="false">
              <li v-if="getRight('ATTENDANCE RECORDS')" :class="{ 'mm-active': selectedSub === 'employee-attendance-records' }">
                <a href="javascript: void(0);" @click="gotTo('employee-attendance-records')">
                  <i class="mdi mdi-clipboard-text"></i> Attendance Records
                </a>
              </li>
              <li v-if="getRight('CLOCK IN OUT')" :class="{ 'mm-active': selectedSub === 'employee-attendance-clock' }">
                <a href="javascript: void(0);" @click="gotTo('employee-attendance-clock')">
                  <i class="mdi mdi-clock-in"></i> Clock In/Out
                </a>
              </li>
              <li v-if="getRight('ATTENDANCE SUMMARY')" :class="{ 'mm-active': selectedSub === 'employee-attendance-summary' }">
                <a href="javascript: void(0);" @click="gotTo('employee-attendance-summary')">
                  <i class="mdi mdi-chart-bar"></i> Attendance Summary
                </a>
              </li>
            </ul>
          </li>

          <li v-if="getRight('MY PAYROLL')" :class="{ 'mm-active': selected === 'employee-payroll' }">
            <a @click="selectedMenu('employee-payroll')" class="waves-effect has-arrow">
              <i class="mdi mdi-cash-multiple"></i>
              <span>My Payroll</span>
            </a>
            <ul :class="{ 'mm-active': selected === 'employee-payroll' }" class="sub-menu" aria-expanded="false">
              <li v-if="getRight('VIEW PAYSLIPS')" :class="{ 'mm-active': selectedSub === 'employee-payroll-payslips' }">
                <a href="javascript: void(0);" @click="gotTo('employee-payroll-payslips')">
                  <i class="mdi mdi-file-document"></i> View Payslips
                </a>
              </li>
              <li v-if="getRight('TAX DOCUMENTS')" :class="{ 'mm-active': selectedSub === 'employee-payroll-tax' }">
                <a href="javascript: void(0);" @click="gotTo('employee-payroll-tax')">
                  <i class="mdi mdi-file-certificate"></i> Tax Documents
                </a>
              </li>
              <li v-if="getRight('PAYROLL HISTORY')" :class="{ 'mm-active': selectedSub === 'employee-payroll-history' }">
                <a href="javascript: void(0);" @click="gotTo('employee-payroll-history')">
                  <i class="mdi mdi-history"></i> Payroll History
                </a>
              </li>
            </ul>
          </li>

          <li v-if="getRight('MY DOCUMENTS')" :class="{ 'mm-active': selected === 'employee-documents' }">
            <a @click="selectedMenu('employee-documents')" class="waves-effect has-arrow">
              <i class="mdi mdi-folder-account"></i>
              <span>My Documents</span>
            </a>
            <ul :class="{ 'mm-active': selected === 'employee-documents' }" class="sub-menu" aria-expanded="false">
              <li v-if="getRight('VIEW DOCUMENTS')" :class="{ 'mm-active': selectedSub === 'employee-documents-view' }">
                <a href="javascript: void(0);" @click="gotTo('employee-documents-view')">
                  <i class="mdi mdi-file-eye"></i> View Documents
                </a>
              </li>
              <li v-if="getRight('UPLOAD DOCUMENTS')" :class="{ 'mm-active': selectedSub === 'employee-documents-upload' }">
                <a href="javascript: void(0);" @click="gotTo('employee-documents-upload')">
                  <i class="mdi mdi-file-upload"></i> Upload Documents
                </a>
              </li>
            </ul>
          </li>

          <li v-if="getRight('MY PERFORMANCE')" :class="{ 'mm-active': selected === 'employee-performance' }">
            <a @click="selectedMenu('employee-performance')" class="waves-effect has-arrow">
              <i class="mdi mdi-trophy"></i>
              <span>My Performance</span>
            </a>
            <ul :class="{ 'mm-active': selected === 'employee-performance' }" class="sub-menu" aria-expanded="false">
              <li v-if="getRight('MY APPRAISALS')" :class="{ 'mm-active': selectedSub === 'my-appraisals' }">
                <a href="javascript: void(0);" @click="gotTo('my-appraisals')">
                  <i class="mdi mdi-file-chart"></i> My Appraisals
                </a>
              </li>
              <li v-if="getRight('SELF ASSESSMENT')" :class="{ 'mm-active': selectedSub === 'employee-self-assessment' }">
                <a href="javascript: void(0);" @click="gotTo('employee-self-assessment')">
                  <i class="mdi mdi-clipboard-edit"></i> Self Assessment
                </a>
              </li>
            </ul>
          </li>

          <li v-if="getRight('MY ANNOUNCEMENTS')" :class="{ 'mm-active': selected === 'employee-announcements' }">
            <a @click="gotToSelected('employee-announcements')" class="waves-effect">
              <i class="mdi mdi-bullhorn"></i><span>Announcements</span>
            </a>
          </li>

        </ul>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import { MetisMenu } from 'metismenujs';
import {authUrl, biller, county_logo, execute, getRight} from "@/api";
export default {
  name: 'NavigationBar',

  data() {
    return {
      isHolidayMenuOpen: false,

      county: {
        id: null,
        countyID: null,
        countyName: null,
        tagline: null,
        smsusername: null,
        smspassword:null,
        contact: null,
        center: null,
        address: null,
        email: null,
        headline: null,
        tagline2: null,
        ussd: null,
        logo: null,
        bank: null,
        powered: null,
        stateLogo: null,
        QRLink:null
      },
      sessionNames:'',
      isVerticalMenuHidden: false,
      permission:"",
      category:"",
      newBill: true,
      dashboard: true,
      paymentsReceipting:true,
      financeAct:true,
      tenantAreas: true,
      bills:true,
      trade: true,
      parking: true,
      reports: true,
      settings: true,
      zones: true,
      users: true,
      liveMonitoring:true,
      transactions: true,
      businessMapping: true,

      selectedSub: null,
      selected: null,
      helmet: {
        names:''
      },
    };
  },
  components: {

  },

  methods:{

    expandHolidayMenu() {
      this.isHolidayMenuOpen = !this.isHolidayMenuOpen;
    },


    getRight(type){
      // Call the imported getRight function
      return getRight(type)
    },

    selectedMenu(selected){
      sessionStorage.setItem("selected",selected)
    },

    gotToSelected(selected){
      sessionStorage.setItem("selected",selected)
      this.$router.push(selected);
    },

    gotTo(route){
      sessionStorage.setItem("selectedSub", route);
      sessionStorage.setItem("currentPage", route);

      if (route.startsWith('holiday')) {
        this.isHolidayMenuOpen = true;
      }

      this.$router.push(route);
    },


    county_logo() {
      return county_logo
    },

    getCounty(){
      const data = new FormData();
      data.append("function", "getCounty");
      execute(data,authUrl)
          .then((res) =>{
            if (res.data.success) {
              this.county = res.data.data.county
            }else{
            }
          })
          .catch((e) => {
            this.message =e.message
          });
    },

    logout(route){
      const data = new FormData();
      data.append("function", "logout");
      data.append("sessionNames",  sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo",  sessionStorage.getItem("sessionIdNo"));
      execute(data,authUrl)
          .then((res) =>{
            sessionStorage.clear()
            this.$router.push(route);

            if (res.data.success) {

            }else{
              this.message =res.data.message
            }
          })
          .catch((e) => {
            this.message =e.message
          });
    }
  },

  mounted() {
    this.getCounty()

    // Get user info from sessionStorage
    const userInfo = JSON.parse(sessionStorage.getItem("userInfo") || '{}');
    this.sessionNames = userInfo.names || sessionStorage.getItem("sessionNames");

    this.names = sessionStorage.getItem("names")
    new MetisMenu('#side-menu');
    this.selected = sessionStorage.getItem("selected")
    this.selectedSub = sessionStorage.getItem("selectedSub")
    this.category = sessionStorage.getItem("category")
    this.permission = sessionStorage.getItem("permission")

    const currentRoute = sessionStorage.getItem("selectedSub");
    if (currentRoute && currentRoute.startsWith('holiday')) {
      this.isHolidayMenuOpen = true;
    }

    // Debug: Log roles to verify they're stored correctly
    console.log("Stored Roles:", sessionStorage.getItem("selectedRoles"));

    // Test a few role checks
    console.log("Has DASHBOARD permission:", this.getRight('DASHBOARD'));
    console.log("Has EMPLOYEE REGISTER permission:", this.getRight('EMPLOYEE REGISTER'));
  }
};
</script>

<style>


.page-topbar {
  transition: margin-left 0.3s ease;
}

.page-topbar-minimize {
  margin-left: 80px;
}

.hide-vertical-menu {
  display: none;
}

.content-minimize {
  transition: margin-left 0.3s ease;
  margin-left: 80px;
}

@media (max-width: 768px) {
  #vertical-menu {
    display: none;
  }

  .hide-vertical-menu #vertical-menu {
    display: block;
  }
  #vertical-menu.show-mobile-verticle{
    display: block !important;
  }
}


@media print {
  .footer,
  .navbar-header,
  .page-title-box,
  .right-bar,
  .vertical-menu {
    display: none!important
  }
  .card-body,
  .content-minimize,
  .page-content,
  .right-bar,
  body {
    padding: 0;
    margin: 0
  }
  .card {
    border: 0
  }
}

.content-minimize {
  margin-left: 250px;
  overflow: hidden
}

.content-minimize .content {
  padding: 0 15px 10px 15px;
  margin-top: 70px
}

@media (max-width:992px) {
  .vertical-menu {
    display: none
  }
  .content-minimize {
    margin-left: 0!important
  }
  body.sidebar-enable .vertical-menu {
    display: block
  }

  #vertical-menu.show-mobile-verticle{
    display: block !important;
  }
}

.vertical-collpsed .content-minimize {
  margin-left: 70px
}

body[data-layout=horizontal] .content-minimize {
  margin-left: 0!important
}


body[data-sidebar-size=small] .content-minimize {
  margin-left: 160px
}

body[data-sidebar-size=small].vertical-collpsed .content-minimize {
  margin-left: 70px
}

.dropdown-item {
  cursor: pointer;
}

</style>